import { GrowthDataSet } from '../types/data-set.types';
import { whoBoysBmiMonthly } from './bmi/bmi-boys';
import { whoGirlsBmiMonthly } from './bmi/bmi-girls';
import {
  whoBoysHeadCircumferenceMonthly,
  whoBoysHeadCircumferenceWeekly,
} from './head-circumference/head-circumference-boys';
import {
  whoGirlsHeadCircumferenceMonthly,
  whoGirlsHeadCircumferenceWeekly,
} from './head-circumference/head-circumference-girls';
import { whoBoysHeightMonthly } from './height/height-boys';
import { whoBoysLengthWeekly } from './height/height-boys-weekly';
import { whoGirlsHeightMonthly } from './height/height-girls';
import { whoGirlsLengthWeekly } from './height/height-girls-weekly';
import {
  whoBoysWeightForLength0to2,
  whoBoysWeightForLength2to5,
} from './weight-for-length/weight-for-length-boys';
import {
  whoGirlsWeightForLength0to2,
  whoGirlsWeightForLength2to5,
} from './weight-for-length/weight-for-length-girls';
import { whoBoysWeightMonthly } from './weight/weight-boys';
import { whoBoysWeightWeekly } from './weight/weight-boys-weekly';
import { whoGirlsWeightMonthly } from './weight/weight-girls';
import { whoGirlsWeightWeekly } from './weight/weight-girls-weekly';

// -----------------------------------------------------------------------------
export const availableDatasets: { [key: string]: GrowthDataSet } = {
  'who-boys-length-weekly': whoBoysLengthWeekly,
  'who-boys-height-monthly': whoBoysHeightMonthly,
  'who-girls-length-weekly': whoGirlsLengthWeekly,
  'who-girls-height-monthly': whoGirlsHeightMonthly,
  'who-girls-weight-weekly': whoGirlsWeightWeekly,
  'who-boys-weight-weekly': whoBoysWeightWeekly,
  'who-girls-weight-monthly': whoGirlsWeightMonthly,
  'who-boys-weight-monthly': whoBoysWeightMonthly,
  'who-girls-bmi-monthly-0-2': whoGirlsBmiMonthly,
  'who-girls-bmi-monthly-2-5': whoGirlsBmiMonthly,
  'who-girls-bmi-monthly-0-5': whoGirlsBmiMonthly,
  'who-boys-bmi-monthly-0-2': whoBoysBmiMonthly,
  'who-boys-bmi-monthly-2-5': whoBoysBmiMonthly,
  'who-boys-bmi-monthly-0-5': whoBoysBmiMonthly,
  'who-girls-head-circumference-monthly-0-5': whoGirlsHeadCircumferenceMonthly,
  'who-girls-head-circumference-weekly-0-13': whoGirlsHeadCircumferenceWeekly,
  'who-boys-head-circumference-monthly-0-5': whoBoysHeadCircumferenceMonthly,
  'who-boys-head-circumference-weekly-0-13': whoBoysHeadCircumferenceWeekly,
  'who-girls-weight-for-length-0-2': whoGirlsWeightForLength0to2,
  'who-girls-weight-for-length-2-5': whoGirlsWeightForLength2to5,
  'who-boys-weight-for-length-0-2': whoBoysWeightForLength0to2,
  'who-boys-weight-for-length-2-5': whoBoysWeightForLength2to5,
};
